import React from 'react';
import './App.css';
import BannerButtons from './components/BannerButtons/BannerButtons';
import Banner from './components/Banner/Banner';
import InfoText from './components/InfoText/InfoText';
import ProjectsList from './components/ProjectsList/ProjectsList';
import Footer from './components/Footer/Footer';
import BackToTop from './components/BackToTop/BackToTop';
import Skills from './components/Skills/Skills';

function App() {
  return (
    <div className="App">
      <Banner></Banner>
      <BannerButtons></BannerButtons>
      <InfoText></InfoText>
      <Skills></Skills>
      <ProjectsList></ProjectsList>
      <BackToTop></BackToTop>
      <Footer></Footer>
    </div>
  );
}

export default App;
